// extracted by css-extract-rspack-plugin
export default {"root":"p8Mw9","spread":"WmuWr","overlay":"XXfwQ","visualization":"YbjpY","warnings":"UN5e7","shadowed":"X9toE"};